import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'


function checkSeatsAndSteeringWheelBadges_q6etron() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}


function addListeners_q6etron(frontCheckboxesMap, modalsCheckboxesMap) {
    frontCheckboxesMap['Q8H'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('Q8H', this.checked);
		if (this.checked) {
			//If we dont come from the modal

		} else {
			checkLocks_q6etron(frontCheckboxesMap)
		}
		getPackageImages_q6etron('Q8H', frontCheckboxesMap)
	})

	frontCheckboxesMap['0UD'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0UD', this.checked);
		if (this.checked) {
			//If we dont come from the modal

		} else {
			checkLocks_q6etron(frontCheckboxesMap)
		}
		getPackageImages_q6etron('0UD', frontCheckboxesMap)
	})

	frontCheckboxesMap['FZ9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FZ9',this.checked)
		checkLocks_q6etron(frontCheckboxesMap)
		getPackageImages_q6etron('FZ9', frontCheckboxesMap)
	})

    frontCheckboxesMap['0TF'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0TF', this.checked);
		if (this.checked) {
			//If we dont come from the modal
		} else {
			checkLocks_q6etron(frontCheckboxesMap)
		}
		getPackageImages_q6etron('0TF', frontCheckboxesMap)
	})


}

/**Controls frontcheckboxes disable */
function checkLocks_q6etron(frontCheckboxesMap) {
    //DEFINE UNLOCK CONDITIONS	
	const unlockConditionForQ8H_7HH = true
	const unlockConditionFor0UD = true
	const unlockConditionForFZ9 = true
	const unlockConditionFor0TF = true

	frontCheckboxesMap['Q8H'].disabled = !unlockConditionForQ8H_7HH
	frontCheckboxesMap['0UD'].disabled = !unlockConditionFor0UD
	frontCheckboxesMap['FZ9'].disabled = !unlockConditionForFZ9
	frontCheckboxesMap['0TF'].disabled = !unlockConditionFor0TF
}


/**Gets images for all packages depending on selected packages */

function getImages_q6etron(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		getPackageImages_q6etron(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_q6etron(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
}


export { addListeners_q6etron, saveStateWithAjax, checkLocks_q6etron, getImages_q6etron, getPackageImages_q6etron, checkSeatsAndSteeringWheelBadges_q6etron}

